type AttachmentCacheKey = {
  accountId: number;
  folder: string;
  uid: number;
  part: string;
};

const MAX_ENTRIES = 48;
const cache = new Map<string, Blob>();

function cacheKey(params: AttachmentCacheKey): string {
  return `${params.accountId}\0${params.folder}\0${params.uid}\0${params.part}`;
}

export function getCachedAttachmentBlob(params: AttachmentCacheKey): Blob | undefined {
  return cache.get(cacheKey(params));
}

export function setCachedAttachmentBlob(params: AttachmentCacheKey, blob: Blob): void {
  const key = cacheKey(params);
  if (cache.has(key)) {
    cache.delete(key);
  }
  cache.set(key, blob);
  while (cache.size > MAX_ENTRIES) {
    const oldest = cache.keys().next().value;
    if (oldest === undefined) break;
    cache.delete(oldest);
  }
}

export function clearAttachmentBlobCache(): void {
  cache.clear();
}
